import Button from "@components/button";
import TickIcon from "@components/icons/tick-icon";
import PlusIcon from "@components/icons/plus-icon";
import * as React from "react";
import { useMutation } from "@tanstack/react-query";
import api, { methods } from "@api";
import { useShoppingcartStore } from "@features/cart/shopping-cart-store";
import { BottomRoots } from "../../Navigator";
import { toast } from "@provider/toast";
import { useBottomTabIndex } from "react-native-ridge-navigation";

function OrderHistoryAddEarlierOrder({ oid, round, small }: { oid: string; round: string; small?: boolean }) {
  const { switchToTab } = useBottomTabIndex();
  const { mutate: addEarlierOrderToCart, isPending } = useMutation({
    mutationFn: () =>
      api<{ group: "success"; products: { quantity: number; pid: number; product_id: number }[] }>({
        path: "/shopping-cart/add-earlier-order",
        method: methods.POST,
        body: { oid, round },
      }),
    onSuccess: (res) => {
      useShoppingcartStore.getState().load();
      // popToTop();
      switchToTab(BottomRoots.Cart);

      // navigate("mand");
    },
    onError: (err) => {
      console.log(err);
      toast.show("Er is iets fout gegaan. Probeer het later opnieuw.");
    },
  });
  return (
    <Button
      py={small ? "$1" : undefined}
      px={small ? "$1" : undefined}
      spacing={small ? "$1" : undefined}
      outline={small}
      onPress={isPending ? () => {} : addEarlierOrderToCart}
      left={
        small ? undefined : isPending ? <TickIcon size={24} color="none" /> : <PlusIcon size={24} color="$background" />
      }
    >
      {small
        ? isPending
          ? `Overnemen... `
          : `Overnemen`
        : isPending
        ? `Aan het overnemen... `
        : `Overnemen naar mand`}
    </Button>
  );
}
export default OrderHistoryAddEarlierOrder;
